import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f69ebc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "absolute transform top-0 right-0 h-10 w-40 bg-gray-200 before:absolute before:-left-8 before:block before:h-full before:w-8 before:bg-inherit before:transform before:skew-x-20 before:origin-top-left before:rounded-bl-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}